// initiation for chord chart
// import ref from './_state';
import typeahead from './render-typeahead';
import update from './_update';
import events from './update-events.js';


export default function (ref) {

    let instance = {};

    // defaults
    let selection = null; // selection element for container
    let dataUrl = null; // path to JSON file

    let data;

    // render/update 
    instance.render = function() {

        d3.json(dataUrl, function(error, json) {
            if (error) return console.warn(error);

            // clean data and keep null values
            json.forEach(function(d) {
                // console.log(d.students);
                
                d.vc_pay = (_.isNull(d.vc_pay)) ? null : +d.vc_pay;
                d.average_pay = (_.isNull(d.average_pay)) ? null : +d.average_pay;
                d.students = (_.isNull(d.students)) ? null : +d.students;
                d.ref = (_.isNull(d.ref)) ? null : +d.ref;
                d.nss = (_.isNull(d.nss)) ? null : +d.nss;

                // create an array of just uni names for typeahead
                ref.uniNames.push(d.university);

            });
            // make data available across scope
            ref.data = json;
            // reference shortcut
            data = ref.data;

            // capture min/max values for reference (save calc them over and over)
            ref.minMaxValues.vc_pay = fc.util.extent().fields(['vc_pay'])(data);
            ref.minMaxValues.average_pay = fc.util.extent().fields(['average_pay'])(data);
            ref.minMaxValues.ref = fc.util.extent().fields(['ref'])(data);
            ref.minMaxValues.nss = fc.util.extent().fields(['nss'])(data);
            ref.minMaxValues.students = fc.util.extent().fields(['students'])(data);
            
            // trigger typeahead
            typeahead(ref);

            // trigger event listeners
            events(ref);

            // run the visualisation
            update(ref);
            // update();


        });

        return instance;
    };
    // api getter/setter
    instance.selection = function(value) {
        if (!arguments.length) return selection;
        selection = value;
        return instance;
    };
    instance.dataUrl = function(value) {
        if (!arguments.length) return dataUrl;
        dataUrl = value;
        return instance;
    };

    return instance;
}